import {Select} from '@mantine/core';
import {useQuery} from '@tanstack/react-query';
import {fetchRecords} from '../../prices/services/PricesService';

interface PriceSelectorProps {
    value: string | null;
    onChange: (priceId: string | null) => void;
    recurringOnly?: boolean;
}

export const PriceSelector = ({value, onChange, recurringOnly}: PriceSelectorProps) => {
    const {data, isLoading} = useQuery({
        queryKey: ['prices-selector'],
        queryFn: () => fetchRecords({}, 100),
    });

    const items = (data?.items || []).filter(p => !recurringOnly || p.recurring?.interval);

    const options = items.map(p => ({
        value: p.id,
        label: `${p.nickname || p.id} - ${p.unitAmount} ${p.currency?.toUpperCase()}${p.recurring?.interval ? ` / ${p.recurring.interval}` : ' (one-time)'}`,
    }));

    return (
        <Select
            label="Price"
            placeholder={isLoading ? 'Loading prices...' : 'Select a price'}
            data={options}
            value={value}
            onChange={onChange}
            searchable
            disabled={isLoading}
        />
    );
};
